module.exports = __webpack_public_path__ + "img/seg1.c8b0407b.jpg";